import { licon, type LiconValue } from 'lib/licon';
import { pubsub } from 'lib/pubsub';
import { type Attrs, hl, type VNode, bind } from 'lib/view';
import { userLine, profileUrl } from 'lib/view/userLink';

import { type Mode, PaneCtrl } from './interfaces';

export class LinksCtrl extends PaneCtrl {
  render = (): VNode => {
    const modeCfg = this.modeCfg;
    return hl('div', [
      this.userLinks(),
      hl('div.subs', [
        hl('button.sub.language', modeCfg('langs'), i18n.site.language),
        hl('button.sub', modeCfg('sound'), i18n.site.sound),
        hl('button.sub', modeCfg('theme'), i18n.site.theme),
        hl('button.sub', modeCfg('board'), i18n.site.board),
        hl('button.sub', modeCfg('piece'), i18n.site.pieceSet),
        this.root.opts.zenable &&
          hl('div.zen.selector', [
            hl(
              'button.text',
              {
                attrs: { 'data-icon': licon.DiscBigOutline, title: 'Keyboard: z', type: 'button' },
                hook: bind('click', () => pubsub.emit('zen')),
              },
              i18n.preferences.zenMode,
            ),
          ]),
      ]),
      this.root.ping.render(),
    ]);
  };

  private get data() {
    return this.root.data;
  }

  private userLinks(): VNode | null {
    const d = this.data;
    const linkCfg = this.linkCfg;
    return d.user
      ? hl('div.links', [
          hl('a.user-link.online', { attrs: { href: profileUrl(d.user.name) } }, [
            userLine(d.user),
            i18n.site.profile,
          ]),
          hl('a.text', linkCfg('/inbox', licon.Envelope), i18n.site.inbox),
          hl(
            'a.text',
            linkCfg(
              '/account/profile',
              licon.Gear,
              this.root.opts.playing ? { target: '_blank' } : undefined,
            ),
            i18n.preferences.preferences,
          ),
          d.coach && hl('a.text', linkCfg('/coach/edit', licon.GraduateCap), i18n.site.coachManager),
          d.streamer && hl('a.text', linkCfg('/streamer/edit', licon.Mic), i18n.site.streamerManager),
          hl('form.logout', { attrs: { method: 'post', action: '/logout' } }, [
            hl('button.text', { attrs: { type: 'submit', 'data-icon': licon.Power } }, i18n.site.logOut),
          ]),
        ])
      : null;
  }

  private readonly modeCfg = (m: Mode) => ({ hook: bind('click', () => this.root.setMode(m)) });

  private readonly linkCfg = (href: string, icon: LiconValue, more?: Attrs) => ({
    attrs: { href, 'data-icon': icon, ...more },
  });
}
